export const API_URL: string =
  (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:3001';

export const WS_URL: string =
  (import.meta.env.VITE_WS_URL as string | undefined) ?? 'ws://localhost:3001';

// Public storefront base URL. In production this is a distinct host from the
// API/admin app, so it must be configured explicitly rather than derived from
// API_URL. Falls back to the local storefront dev server.
export const STOREFRONT_URL: string =
  (import.meta.env.VITE_STOREFRONT_URL as string | undefined) ?? 'http://localhost:5174';

/** Canonical marketing site, including public legal documents. */
export const SITE_URL: string =
  (import.meta.env.VITE_SITE_URL as string | undefined)?.trim() || 'https://cartiq.shop';

export const API_BASE = `${API_URL}/api`;

/** Build the public URL for a merchant's storefront from its slug. */
export function storeUrlForSlug(slug: string): string {
  return `${STOREFRONT_URL.replace(/\/$/, '')}/${slug}`;
}
